// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table th[data-v-407ae65d]{border-top:none}#myContainer[data-v-407ae65d]{width:1000px}.popover[data-v-407ae65d]{max-width:100%}", ""]);
// Exports
module.exports = exports;
